module.exports = __webpack_public_path__ + "static/media/BAJAJ-AUTO.9d644072.txt";